module.exports = __webpack_public_path__ + "static/categories_inserted-11aebafc71030d386b211fdb9cdcec1e.png";